import React from 'react';
import styled from 'styled-components';

interface Props {
  children: JSX.Element;
  onClickEventLog: () => void;
}
const ClickEventLoggerWrapper = ({ children, onClickEventLog }: Props) => {
  return (
    <Wrapper role='button' onClick={onClickEventLog}>
      {children}
    </Wrapper>
  );
};

export default ClickEventLoggerWrapper;

const Wrapper = styled.div``;
